export default __webpack_public_path__ + "images/b3929f5dc112684aaf3cdf2cbdb6ce5e.jpg";